import React, { FC } from 'react';
import styled from 'styled-components';

type UsuarioIdentificacaoProps = {
  usuario: string;
  nome?: string;
};

const Identificacao = styled.span`
  align-items: center;
  background: #fff;
  border: 1px solid #d7d7d7;
  border-radius: 18px;
  display: inline-flex;
  gap: 8px;
  padding: 3px 10px 3px 3px;
  position: relative;

  &:hover::after {
    background: #333;
    border-radius: 3px;
    color: #fff;
    content: attr(data-tooltip);
    font-size: 12px;
    left: 0;
    padding: 6px 10px;
    position: absolute;
    top: calc(100% + 6px);
    white-space: nowrap;
    z-index: 1;
  }
`;

const Avatar = styled.span`
  align-items: center;
  background: #75d49a;
  border-radius: 50%;
  color: #1f5e36;
  display: inline-flex;
  font-size: 12px;
  font-weight: 600;
  height: 28px;
  justify-content: center;
  width: 28px;
`;

const getIniciais = (nome: string) => {
  const nomes = nome.trim().split(/\s+/).filter(Boolean);
  const primeiroNome = nomes[0] || '';
  const sobrenome = nomes[nomes.length - 1] || '';

  return `${primeiroNome.charAt(0)}${
    sobrenome !== primeiroNome ? sobrenome.charAt(0) : ''
  }`.toUpperCase();
};

const UsuarioIdentificacao: FC<UsuarioIdentificacaoProps> = ({
  usuario,
  nome
}) => {
  const identificacao = nome || usuario;

  return (
    <Identificacao data-tooltip={identificacao} title={identificacao}>
      <Avatar aria-hidden>{getIniciais(identificacao)}</Avatar>
      <span>{usuario}</span>
    </Identificacao>
  );
};

export { UsuarioIdentificacao };
